import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { Config } from "../../../../../../Config";
import CoreInfo from "./Components/CoreInfo";
import Preferences from "./Components/Preferences";
import Skills from "./Components/Skills";

const EditPreferences = (props) => {
  const [TabIds] = useState(["core", "preferences", "skills-tab"]);
  const [ActiveTab, setActiveTab] = useState("core");
  const [HasMadeChanges, setHasMadeChanges] = useState(false);
  const [UserInfo, setUserInfo] = useState();
  const [SelectedPaths, setSelectedPaths] = useState();
  const [Countries, setCountries] = useState();
  const [Languages, setLanguages] = useState();
  const [SelectedSkills, setSelectedSkills] = useState();

  const CoreRef = useRef(null);

  useEffect(() => {
    fetchUserInfo();
    fetchCountries();
    fetchLanguages();
  }, []);

  useEffect(() => {
    setHasMadeChanges(false);
    props.SetHasUnsavedChanges(false);
    setUserInfo(undefined);
    fetchUserInfo();
  }, [props.CancelConfirmed]);

  useEffect(() => {
    document.getElementById(
      "animated-indicator"
    ).style.width = `${CoreRef.current?.clientWidth}px`;
  }, [CoreRef.current?.clientWidth]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const fetchCountries = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/user-info/countries",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setCountries(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchLanguages = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/language/batch",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Langs = [];
        Res.data.map((Lang) => {
          if (Lang.name === "DE" || Lang.name === "EN") {
            // temporary condition, must remove after ES and FR labels are added
            Langs.push({
              name: swapLanguageName(Lang.name),
              id: Lang.name,
            });
          }
        });
        setLanguages(Langs);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const swapLanguageName = (Name) => {
    switch (Name) {
      case "EN":
        return "English";
      case "FR":
        return "French";
      case "ES":
        return "Spanish";
      case "DE":
        return "German";
    }
  };

  const fetchUserInfo = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user-info",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setUserInfo(Res.data);
        setSelectedPaths(Res.data.path);
        setSelectedSkills(Res.data.skills);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const validateNavigation = (e, Id) => {
    props.SetPrefTabClicked(Id);

    if (props.HasUnsavedChanges) {
      props.DisplayUnsavedChangesModal(true);
    } else {
      transformIndicator(Id);
    }
  };

  const transformIndicator = (Id) => {
    setHasMadeChanges(false);
    props.ResetLastTabInfo();
    // Id is the id of the clicked tab
    setActiveTab(Id);
    TabIds.map((Tab) => {
      document.getElementById(Tab).classList.remove("active-nav-node");
    });
    document.getElementById(Id).classList.add("active-nav-node");
    document
      .getElementById("animated-indicator")
      .classList.remove("transform-pos-2");
    document
      .getElementById("animated-indicator")
      .classList.remove("transform-pos-1");
    document
      .getElementById("animated-indicator")
      .classList.remove("transform-pos-3");
    if (Id === "preferences") {
      document
        .getElementById("animated-indicator")
        .classList.add("transform-pos-2");
    } else if (Id === "core") {
      document
        .getElementById("animated-indicator")
        .classList.add("transform-pos-1");
    } else {
      document
        .getElementById("animated-indicator")
        .classList.add("transform-pos-3");
    }
  };

  const displayFormTitle = () => {
    if (ActiveTab === "core") {
      return translateText("personal_information");
    } else if (ActiveTab === "preferences") {
      return translateText("preferences");
    } else {
      return translateText("skills_and_experience");
    }
  };

  const handleSave = () => {
    if (ActiveTab === "preferences") {
      savePreferences();
    } else {
      saveSkills();
    }
  };

  const savePreferences = () => {
    let Data = {
      id: UserInfo.id,
      countryId: document.getElementById("selected-preferred-country-input")
        .value,
      anonymous: true,
      path: SelectedPaths,
      language: "EN",
    };

    let LanguageId = document.getElementById("selected-language-input").value;
    let LanguageName;
    Languages.map((Lang) => {
      if (Lang.id === LanguageId) {
        LanguageName = Lang.name;
      }
    });

    if (
      document
        .getElementById("anonymous-switch-holder")
        .classList.contains("off")
    ) {
      Data.anonymous = false;
    }

    if (LanguageName === "English") {
      Data.language = "EN";
    } else if (LanguageName === "Spanish") {
      Data.language = "ES";
    } else if (LanguageName === "French") {
      Data.language = "FR";
    } else if (LanguageName === "German") {
      Data.language = "DE";
    }

    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/user-info/preferences",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    // Validation to prevent saving no path items
    if (SelectedPaths === "") {
      document.getElementById("path-error-text").style.display = "block";
      setTimeout(() => {
        if (document.getElementById("path-error-text") !== null) {
          document.getElementById("path-error-text").style.display = "none";
        }
      }, 5000);
    } else {
      axios(Req)
        .then((Res) => {
          console.log(Res);
          props.SetHasUnsavedChanges(false);
          window.localStorage.setItem("HasUnsaveChanges", "0");

          if (props.SaveAndLeaveIsOn) {
            props.NavigateToSelectedTabAfterSave();
            props.SetSaveAndLeaveIsOn(false);
          }
          setHasMadeChanges(false);
          fetchUserInfo();
          window.localStorage.setItem("LangChanged", true); // for the listener function in Dashboard.js
        })
        .catch((Err) => {
          console.log(Err);

          if (props.SaveAndLeaveIsOn) {
            props.SetSaveAndLeaveIsOn(false);
          }
        });
    }
  };
  const saveSkills = () => {
    let Data = {
      id: UserInfo.id,
      yearsOfExperience: parseInt(
        document.getElementById("yoe-single").innerHTML
      ),
      skills: [],
    };
    SelectedSkills.map((Skill) => {
      Data.skills.push(Skill.id);
    });

    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/user-info/skills",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    if (SelectedSkills.length < 5) {
    } else {
      axios(Req)
        .then((Res) => {
          console.log(Res);
          props.SetHasUnsavedChanges(false);
          window.localStorage.setItem("HasUnsaveChanges", "0");

          if (props.SaveAndLeaveIsOn) {
            props.NavigateToSelectedTabAfterSave();
            props.SetSaveAndLeaveIsOn(false);
          }
          fetchUserInfo();
          setHasMadeChanges(false);
        })
        .catch((Err) => {
          console.log(Err);

          if (props.SaveAndLeaveIsOn) {
            props.SetSaveAndLeaveIsOn(false);
          }
        });
    }
  };

  const handleBackButtonAction = () => {
    props.SetWillReturnToHomePage(true);
    if (props.HasUnsavedChanges) {
      props.DisplayUnsavedChangesModal(true);
    } else {
      document.getElementById("link-to-home").click();
    }
  };

  const handleCancel = () => {
    props.SetModalTypeIsCancel(true);
    if (props.HasUnsavedChanges) {
      props.DisplayUnsavedChangesModal(true);
    }
  };

  return (
    <main className="edit-preferences-wrapper bg-column">
      <div className="navigator-holder">
        <div className="actions navigator">
          <span className="animated-indicator" id="animated-indicator"></span>
          <p
            onClick={(e) => validateNavigation(e, "core")}
            className="tab-item active-nav-node"
            id="core"
            ref={CoreRef}
          >
            <p>{translateText("core_info")}</p>
          </p>
          <p
            onClick={(e) => validateNavigation(e, "preferences")}
            id="preferences"
            className="tab-item"
          >
            <p>{translateText("preferences")}</p>
          </p>
          <p
            onClick={(e) => validateNavigation(e, "skills-tab")}
            id="skills-tab"
            className="tab-item"
          >
            <p>{translateText("skills")}</p>
          </p>
        </div>
      </div>

      <section
        className={
          ActiveTab === "core"
            ? "bg-colum-head read-only-head"
            : "bg-colum-head"
        }
      >
        <i
          className="feather-arrow-left"
          onClick={() => handleBackButtonAction()}
        ></i>
        <NavLink to="/" id="link-to-home"></NavLink>
        <h1>{displayFormTitle()}</h1>
        <div
          className={
            ActiveTab === "core" ? "head-actions hidden" : "head-actions"
          }
        >
          <span
            className={
              HasMadeChanges
                ? "head-action-btn secondary-action"
                : "head-action-btn secondary-action disabled"
            }
            onClick={() => handleCancel()}
          >
            {translateText("cancel")}
          </span>
          <span
            className={
              HasMadeChanges
                ? "head-action-btn primary-action"
                : "head-action-btn primary-action disabled"
            }
            onClick={() => handleSave()}
            id="save-btn"
          >
            {translateText("save")}
          </span>
        </div>
      </section>
      <div className="preferences-main-content">
        {ActiveTab === "core" ? (
          <CoreInfo
            LangData={props.LangData}
            HasUnsavedChanges={props.HasUnsavedChanges}
            DisplayUnsavedChangesModal={(Bool) =>
              props.DisplayUnsavedChangesModal(Bool)
            }
          />
        ) : (
          <React.Fragment>
            {UserInfo === undefined ? null : (
              <React.Fragment>
                {ActiveTab === "preferences" ? (
                  <Preferences
                    SetHasMadeChanges={(Status) => setHasMadeChanges(Status)}
                    SavePathItems={(PathItems) =>
                      setSelectedPaths(PathItems.toString())
                    }
                    UserInfo={UserInfo}
                    Languages={Languages}
                    Countries={Countries}
                    LangData={props.LangData}
                    HasUnsavedChanges={props.HasUnsavedChanges}
                    SetHasUnsavedChanges={(Bool) =>
                      props.SetHasUnsavedChanges(Bool)
                    }
                    DisplayUnsavedChangesModal={(Bool) =>
                      props.DisplayUnsavedChangesModal(Bool)
                    }
                  />
                ) : (
                  <Skills
                    UserInfo={UserInfo}
                    SetHasMadeChanges={(Status) => setHasMadeChanges(Status)}
                    LangData={props.LangData}
                    SaveSkills={(SelectedSkills) =>
                      setSelectedSkills(SelectedSkills)
                    }
                    HasUnsavedChanges={props.HasUnsavedChanges}
                    SetHasUnsavedChanges={(Bool) =>
                      props.SetHasUnsavedChanges(Bool)
                    }
                    DisplayUnsavedChangesModal={(Bool) =>
                      props.DisplayUnsavedChangesModal(Bool)
                    }
                  />
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    </main>
  );
};

export default EditPreferences;
